import React, {useContext} from "react";
import Button from "components/Button";
import ReplayIcon from "@material-ui/icons/Replay";
import {simpleConfirmNoTranslate} from "libs/ConfirmNotification";
import Tr from "translations/Translations";
import AnnualReportsService from "services/AnnualReportsService";
import PropTypes from "prop-types";
import FormTranslationContext from "context/FormTranslationContext";
import {useParams} from "react-router";


function ReloadAnnualReportTableButton(
    {
        classes,
        reportStep,
        disabled
    }) {

    const params = useParams();
    const {formTr} = useContext(FormTranslationContext);
    return (<Button className={classes.marginRight} variant="outlined" disabled={disabled} Icon={ReplayIcon}
                    onClick={() => simpleConfirmNoTranslate(Tr("annual_report_reload_table_confirm", {x: formTr("mmia." + reportStep).substring(0, formTr("mmia." + reportStep).indexOf("."))}),
                        () => AnnualReportsService.initializeTable(params.id, reportStep)
                    )}>
        {Tr("annual_report_reload_table")}
    </Button>)
}

ReloadAnnualReportTableButton.propTypes = {
    classes: PropTypes.object.isRequired,
    reportStep: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
}

export default ReloadAnnualReportTableButton;